import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrManager } from 'ng6-toastr-notifications';
import { CommonService, SharedserviceService } from 'src/app/services';
import {Sort} from '@angular/material/sort';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { DatePipe } from '@angular/common';
declare var $:any;




@Component({
  selector: 'app-account-balance', 
  templateUrl: './account-balance.component.html',
  styleUrls: ['./account-balance.component.scss'],
  providers:[DatePipe,NgxUiLoaderService]
})

export class AccountBalanceComponent implements OnInit{
date:any;
@ViewChild("fileInput1", {static: false}) fileInput1: ElementRef;files = [];
@ViewChild("inputSearch", {static: false}) inputSearch: ElementRef;
ccData:any;
compData:any;
compDtl:any=[];
sortedList: any[];
old_credit_limit:any;
// ngxLoader:any;
detail_data:any;
submitted:boolean=false;
searchFlagReset:boolean=false;bodydata:any={};
TotalCount:any;data:any;keys:any;public page: number = 1;start = 0;msg:any;status:any;FormId:any;flag:boolean=false;
accountData:any;
account:any;
resltData:any=[];
todaydate:any= this.datePipe.transform(new Date(), 'dd/MM/yyyy')
  public addaccountValue : FormGroup; 
  element:any;
  
  constructor(
    private fb: FormBuilder, 
    public sharedService: SharedserviceService, 
    public router: Router,
    private datePipe: DatePipe,
    private toastr: ToastrManager,
    private activatedRoute:ActivatedRoute,
    public dataservice:CommonService,
    private ngxLoader: NgxUiLoaderService,
  ) { 
    this.sortedList=this.ccData;
  }

  ngOnInit() {
    this.bodydata={
      page_limit: "10",
      page_no:this.bodydata['page_no'],
      search_value: "",
      order_key: "desc",
      order_value: ""
  }
  this.bodydata['page_no']='1';
    this.accountDtl(this.bodydata);
  }

   //*********shorting Start*********** */
   sortData(sort: Sort) {
    const data = this.ccData;
    if (!sort.active || sort.direction === '') {
      this.sortedList = data;
      return;
    }
    this.sortedList = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'balance_transaction_date_time': return compare(a.balance_transaction_date_time, b.balance_transaction_date_time, isAsc);
        case 'narration': return compare(a.narration, b.narration, isAsc);
        case 'amount': return compare(a.amount, b.amount, isAsc);
        case 'account_type': return compare(a.account_type, b.account_type, isAsc);
        // case 'website': return compare(a.website, b.website, isAsc);
        default: return 0;
      }
    });
    function compare(a: number | string, b: number | string, isAsc: boolean) {
      return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
    }
  }
  
  accountDtl(bodydata){        
    this.ngxLoader.start();
    const self=this;
    self.sharedService.post('v1/vendor_account/company_account_details', bodydata).subscribe((res: any) => {
        if (res.replyCode == "success" ) {
             this.ccData = res.data; 
             this.resltData = res; 
            if((res.data).length>0){
              this.data = res.data;
              this.compDtl= res.company_details;

              this.keys = Object.keys(this.data[0]);
              this.TotalCount = res.totalRecords;
              this.ngxLoader.stop();
            }else{
              this.ngxLoader.stop();
              this.msg ='No Record Found..'
            }
        }else{
          this.ngxLoader.stop();
           self.toastr.errorToastr("Result Not Found","Error");
        }        
     },err=>{
        this.ngxLoader.stop();
         self.toastr.errorToastr(err.error.replyMsg,"Error");
     });       
}

onSearch(){
    this.searchFlagReset = true;
    var requestdata={
      page_limit: "10",
      page_no: "1",
      search_value:  String(this.inputSearch.nativeElement.value),
      order_key: "",
      order_value: ""
    }
    this.accountDtl(requestdata);
}
  onReset(){
    // this.searchFlagReset = false;
    // this.element['search'] = '';
    // this.inputSearch.nativeElement.value='';
    // this.accountDtl(this.bodydata);

    let currentUrl = this.router.url;
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate([currentUrl]);
  }
  onPageChange(event) {
    this.bodydata['page_no'] = event;
    this.accountDtl(this.bodydata);   
  }

}


